export default __webpack_public_path__ + "static/media/banner-select-word-card.59f671a5.png";